export default "__VITE_ASSET___JiVpoTG__"